function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  xmlnsXlink: "http://www.w3.org/1999/xlink",
  viewBox: "0 0 45 58"
}, props), React.createElement("defs", null, React.createElement("linearGradient", {
  id: "svg4163642745b",
  x1: "86.94%",
  x2: "4.61%",
  y1: "9.96%",
  y2: "98.07%"
}, React.createElement("stop", {
  offset: "0%",
  stopColor: "#50D1AD"
}), React.createElement("stop", {
  offset: "100%",
  stopColor: "#57B5C6"
})), React.createElement("path", {
  id: "svg4163642745a",
  d: "M21.384 4C11.798 4 4 11.798 4 21.384c0 11.895 15.557 29.36 16.22 30.097a1.566 1.566 0 002.328 0c.663-.738 16.22-18.202 16.22-30.097C38.768 11.798 30.969 4 21.384 4zm0 26.13c-4.823 0-8.746-3.924-8.746-8.746 0-4.823 3.923-8.746 8.746-8.746 4.822 0 8.746 3.923 8.746 8.746 0 4.822-3.924 8.746-8.746 8.746z"
})), React.createElement("g", {
  fill: "none",
  fillRule: "evenodd",
  transform: "translate(1 1)"
}, React.createElement("path", {
  fill: "#F5F5F5",
  fillRule: "nonzero",
  d: "M21.384 0c11.794 0 21.384 9.59 21.384 21.384 0 6.23-3.204 13.474-8.536 21.455a109.736 109.736 0 01-5.754 7.81l-.699.858-.668.806-.925 1.087-.256.295-.405.458a5.566 5.566 0 01-8.282 0l-.53-.6-.734-.857-.652-.779a109.736 109.736 0 01-6.791-9.078C3.202 34.858 0 27.614 0 21.384 0 9.589 9.59 0 21.384 0zm0 4C11.798 4 4 11.798 4 21.384 4 31.852 16.047 46.632 19.39 50.53l.83.95.107.109a1.566 1.566 0 002.221-.11l.616-.7c3.003-3.474 15.604-18.69 15.604-29.396C38.768 11.798 30.969 4 21.384 4zm0 4.638c7.032 0 12.746 5.714 12.746 12.746S28.416 34.13 21.384 34.13 8.638 28.416 8.638 21.384 14.352 8.638 21.384 8.638zm0 4c-4.823 0-8.746 3.923-8.746 8.746 0 4.822 3.923 8.746 8.746 8.746 4.822 0 8.746-3.924 8.746-8.746 0-4.823-3.924-8.746-8.746-8.746z"
}), React.createElement("mask", {
  id: "svg4163642745c",
  fill: "#fff"
}, React.createElement("use", {
  xlinkHref: "#svg4163642745a"
})), React.createElement("g", {
  fill: "url(#svg4163642745b)",
  mask: "url(#svg4163642745c)"
}, React.createElement("path", {
  d: "M-2 4h48v48H-2z"
})), React.createElement("circle", {
  cx: "21.5",
  cy: "21.5",
  r: "9.5",
  fill: "#F5F5F5"
}))));